export const css = {
    root: 'OeNdA9NI',
    input: '_2elUe2Rk',
    inputWrapper: '_1wmF-fRb',
    radioBackground: '_22PwXPsD',
    radioOuter: '_3BUHITiA',
    radioInner: '_1efHBNiV',
    focused: '_1MmLUzN8',
    checked: '_1CL4rJDW',
    disabled: '_308rMEt8',
    readonly: '_2G-sKMzg',
    invalid: '_3Jhkv6bj',
    valid: 'G34kvPKf',
    ' _key': 'apic-theme/apic/dojo/radio'
};
export default css;
